export default "__VITE_ASSET__CmbUBmJ8__"